package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_flow

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_flow.component.IncomeExpanses
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_flow.component.PaymentMethods
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun CashFlow(
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum
)
{

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .padding(
                bottom =  Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            ),
        horizontalAlignment = Alignment.Start
    ){

        PaymentMethods(
           creditCards = state.appConfig?.creditCards,
           windowSizeMode=windowSizeMode,
           updateCreditCards = {
               event(OptionsEvent.UpdateAppConfig(
                   title=ApiUtils.Field.creditCards,
                   value=it
               ))
           }
        )

        IncomeExpanses(
            specialProductExpenses=state.appConfig?.specialProductExpenses,
            windowSizeMode=windowSizeMode,
            updateIncomeExpanses = {
                event(OptionsEvent.UpdateAppConfig(
                    title=ApiUtils.Field.specialProductExpenses,
                    value=it
                ))
            }
        )








    }
}